import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  withDefaults,
  inject,
  watch,
  ref,
  Ref,
} from "../../../../adapter-vue";
import TUIChatEngine, {
  TUITranslateService,
  IGroupModel,
  FriendApplication,
  Friend,
} from "@tencentcloud/chat-uikit-engine";
import { IContactInfoType, IUserStatus } from "../../../../interface";
import Avatar from "../../../common/Avatar/index.vue";
import {
  generateAvatar,
  generateName,
  acceptFriendApplication,
} from "../../utils";
import { isPC } from "../../../../utils/env";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    item: { default: () => ({} as IContactInfoType) },
    displayOnlineStatus: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { item: IContactInfoType, displayOnlineStatus: boolean }


const userOnlineStatusMap = inject<Ref<Map<string, IUserStatus>>>(
  "userOnlineStatusMap"
);
const isOnline = ref<boolean>(false);

const groupType = {
  [TUIChatEngine.TYPES.GRP_WORK]: "Work",
  [TUIChatEngine.TYPES.GRP_AVCHATROOM]: "AVChatRoom",
  [TUIChatEngine.TYPES.GRP_PUBLIC]: "Public",
  [TUIChatEngine.TYPES.GRP_MEETING]: "Meeting",
  [TUIChatEngine.TYPES.GRP_COMMUNITY]: "Community",
};

const otherContentForSow = computed((): string => {
  let content = "";
  if (
    (props.item as FriendApplication)?.type ===
      TUIChatEngine?.TYPES?.SNS_APPLICATION_SENT_TO_ME ||
    (props.item as FriendApplication)?.type ===
      TUIChatEngine?.TYPES?.SNS_APPLICATION_SENT_BY_ME
  ) {
    content = (props.item as FriendApplication)?.wording || "";
  } else if ((props.item as IGroupModel)?.groupID) {
    content = `ID:${(props.item as IGroupModel)?.groupID}`;
  }
  return content;
});

const groupTypeForShow = computed((): string => {
  let type = "";
  if ((props.item as IGroupModel)?.groupID) {
    type = groupType[(props.item as IGroupModel)?.type];
  }
  return type;
});

const showApplicationStatus = computed(() => {
  if (
    (props.item as FriendApplication)?.type ===
    TUIChatEngine?.TYPES?.SNS_APPLICATION_SENT_BY_ME
  ) {
    return {
      style: "text",
      label: "等待验证",
    };
  } else if (
    (props.item as FriendApplication)?.type ===
    TUIChatEngine?.TYPES?.SNS_APPLICATION_SENT_TO_ME
  ) {
    return {
      style: "button",
      label: "同意",
      onClick: () => {
        acceptFriendApplication((props.item as FriendApplication)?.userID);
      },
    };
  }
  return false;
});

watch(
  () => userOnlineStatusMap?.value,
  () => {
    isOnline.value = getOnlineStatus();
  },
  {
    immediate: true,
    deep: true,
  }
);

function getOnlineStatus(): boolean {
  return !!(
    props.displayOnlineStatus &&
    userOnlineStatusMap?.value &&
    (props.item as Friend)?.userID &&
    userOnlineStatusMap.value?.[(props.item as Friend).userID]?.statusType ===
      TUIChatEngine.TYPES.USER_STATUS_ONLINE
  );
}

return { __sfc: true,props, userOnlineStatusMap, isOnline, groupType, otherContentForSow, groupTypeForShow, showApplicationStatus, getOnlineStatus, TUITranslateService, Avatar, generateAvatar, generateName, isPC }
}

})